import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { Pressable } from "@/components/common";
import FormFieldListItem from "./formFieldListItem";

const AddFormFieldsTableSection = ({
  savedData,
  handleDragEndDataForSavedData,
  handleChildFormModal,
  handleFormFieldUpdate,
  handleFormFieldDelete,
  testId,
  handleFormModal,
  isSubmitLoading,
  isDisabled,
  handleSubmitForm,
  onCancel,
}) => {
  return (
    <>
      {savedData && savedData.length > 0 && (
        <Row className="mx-4 mt-3">
          <Col>
            <div className="m-0 rounded mt-2 Shadow">
              <Table responsive className="mb-0 border-bottom-none">
                <thead>
                  <tr style={{ borderBottom: "3px solid #cdcdcd" }}>
                    <th></th>
                    <th className="col-xs-1 col-sm-1 col-lg-1 C-primary">Id</th>
                    <th className="col-xs-3 col-sm-3 col-lg-4 C-primary">
                      Fields Name
                    </th>
                    <th className="col-xs-3 col-sm-3 col-lg-4 C-primary">
                      Fields Type
                    </th>
                    <th className="col-xs-3 col-sm-3 col-lg-4 C-primary">Status</th>
                    <th className="col-xs-2 col-sm-2 col-lg-3 C-primary">Action</th>
                  </tr>
                </thead>
                <FormFieldListItem
                  savedData={savedData}
                  handleDragEndDataForSavedData={handleDragEndDataForSavedData}
                  handleChildFormModal={handleChildFormModal}
                  handleFormFieldUpdate={handleFormFieldUpdate}
                  handleFormFieldDelete={handleFormFieldDelete}
                  testId={testId}
                />
              </Table>
            </div>
          </Col>
        </Row>
      )}
      <Row className="mx-4">
        <div className="mt-5">
          <Pressable
            type="button"
            classes="w-25"
            title="Form Fields +"
            onPress={handleFormModal}
            style={{ minWidth: "80px", maxWidth: "150px" }}
            id={`${testId}.button.addFields`}
          />
        </div>
      </Row>
      <Row className=" mt-3 mx-4">
        <div className="d-flex justify-content-end">
          <div className="px-3">
            <Pressable
              type="button"
              title="Cancel"
              onPress={onCancel}
              classes="bg-light text-black w-25"
              style={{ minWidth: "100px", maxWidth: "170px" }}
              id={`${testId}.button.cancel`}
            />
          </div>
          <div>
            <Pressable
              type="button"
              title="Save"
              classes="w-25"
              loading={isSubmitLoading}
              disabled={isDisabled}
              onPress={handleSubmitForm}
              style={{ minWidth: "100px", maxWidth: "170px" }}
              id={`${testId}.button.save`}
            />
          </div>
        </div>
      </Row>
    </>
  );
};

export default AddFormFieldsTableSection;
